<script lang="ts">
	import TermsOfService from "../../organisms/settings/TermsOfService.svelte";
</script>

<div class="flex">
	<div class="flex-1 mr-8">
		<TermsOfService/>
	</div>
</div>